module.exports = __webpack_public_path__ + "static/media/ceyla.dbd91660.jpg";